import { isPlatformSuperAdmin } from '../../../utils/isPlatformSuperAdmin.ts';

export function canSetStandardProfile(user) {
  if (!user) {
    return false;
  }
  return user.is_superuser === true || isPlatformSuperAdmin(user);
}

export function getLoggedInOrganisation(user) {
  const organisation = user?.profile?.organisation;
  if (!organisation?.organisation_id) {
    return null;
  }
  return {
    organisation_id: organisation.organisation_id,
    name: organisation.name || '',
  };
}

export function buildDefaultProfileFormValues(user) {
  return {
    organisation: getLoggedInOrganisation(user),
    name: '',
    is_standard: false,
    sessionDays: 0,
    sessionHours: 0,
    sessionMinutes: 0,
  };
}
